import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38178f31"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "jamfpro-instructions"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "To automate the deployment and pairing of Ditto Receiver using Jamf Pro, add the configuration settings listed below as the App Configuration for the Ditto Receiver Mobile Device App setup in Jamf Pro.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("em", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://docs.jamf.com/jamf-pro/administrator-guide/App_Store_Apps.html",
      target: "_blank",
      rel: "noreferrer noopener",
      class: "link"
    }, "See more details"),
    /*#__PURE__*/_createTextVNode(" on creating an App Configuration for a tvOS application in Jamf Pro.")
  ])
], -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://help.airsquirrels.com/ditto/354-how-to-mass-deploy-the-ditto-tvos-receiver-using-jamf",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link"
  }, "Need more information?")
], -1))
const _hoisted_6 = {
  key: 1,
  class: "jamfpro-instructions"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "To automate the deployment and pairing of Ditto Receiver using Jamf School, add the configuration settings listed below as the App Configuration for the Ditto Receiver Mobile Device App setup in Jamf Jamf School.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("em", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://docs.jamf.com/jamf-pro/administrator-guide/App_Store_Apps.html",
      target: "_blank",
      rel: "noreferrer noopener",
      class: "link"
    }, "See more details"),
    /*#__PURE__*/_createTextVNode(" on creating an App Configuration for a tvOS application in Jamf School.")
  ])
], -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://help.airsquirrels.com/ditto/354-how-to-mass-deploy-the-ditto-tvos-receiver-using-jamf",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link"
  }, "Need more information?")
], -1))
const _hoisted_11 = {
  key: 2,
  class: "jamfpro-instructions"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "To automate the deployment of Ditto Receiver using Meraki, create a Device Profile for tvOS with a Managed App Config Payload with the settings listed below. You can also download the Ditto AirPlay Disabling Profile and upload it as a \"custom Apple profile\" in the Meraki Settings Profiles section.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("em", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://documentation.meraki.com/SM/Profiles_and_Settings/Using_the_Managed_App_Settings_Payload",
      target: "_blank",
      rel: "noreferrer noopener",
      class: "link"
    }, "See more details"),
    /*#__PURE__*/_createTextVNode(" on creating a Managed App Config payload Device Profile in Meraki.")
  ])
], -1))
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "my-2" }
const _hoisted_16 = {
  href: " ./mdm/Ditto-Receiver-Settings.mobileconfig",
  target: "_blank",
  rel: "noreferrer noopener"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "https://help.airsquirrels.com/ditto/353-how-to-mass-deploy-the-ditto-tvos-receiver-using-meraki",
  target: "_blank",
  rel: "noreferrer noopener"
}, "Need more information?", -1))
const _hoisted_18 = {
  key: 3,
  class: "jamfpro-instructions"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "If you have an MDM system that supports tvOS devices and App Configuration, you can configure Apple TV to auto-deploy and pair Ditto Receiver. You will need to ensure the organizationId and deploymentCode listed below are included in the profile.", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("em", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://support.apple.com/guide/mdm/app-configuration-mdmcdc2bfa19/1/web/1",
      target: "_blank",
      rel: "noreferrer noopener",
      class: "link"
    }, "See more details"),
    /*#__PURE__*/_createTextVNode(" on App Config payloads.")
  ])
], -1))
const _hoisted_21 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.deploymentOption == 'JamfPro')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("code", { innerHTML: _ctx.sanitizedMdmProfile }, null, 8, _hoisted_4),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.deploymentOption == 'JamfSchool')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("code", { innerHTML: _ctx.sanitizedMdmProfile }, null, 8, _hoisted_9),
          _hoisted_10
        ]))
      : _createCommentVNode("", true),
    (_ctx.deploymentOption == 'CiscoMeraki')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _createElementVNode("div", { innerHTML: _ctx.sanitizedMdmProfile }, null, 8, _hoisted_14),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", _hoisted_16, [
              _createVNode(_component_el_button, {
                type: "primary",
                plain: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("AirPlay Disabling Profile")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_17
        ]))
      : _createCommentVNode("", true),
    (_ctx.deploymentOption == 'Other')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("div", { innerHTML: _ctx.sanitizedMdmProfile }, null, 8, _hoisted_21)
        ]))
      : _createCommentVNode("", true)
  ]))
}